/**
* @Name: Constants
* @Creation Date: July 31, 2017
* @Author: sbaireddy
* @Version: 1.0 :
*/

export let CACHE_RATEPLAN_LIST_GSM: string = 'rateplan_list_gsm';
export let CACHE_RATEPLAN_LIST_DATA: string = 'rateplan_list_data';
export let CACHE_DEVICE_LIST_GSM: string = 'device_list_gsm';
export let CACHE_DEVICE_LIST_DATA: string = 'device_list_data';
export let CACHE_FEATURE_LIST: string = 'feature_list';
export let CACHE_ACCESSORY_LIST: string = 'accessory_list';
export let CACHE_INVENTORY_LIST: string = 'inventory_list';
export let CACHE_TRADEIN_DEVICE_LIST: string = 'tradein_device_list';

export let CACHE_RATEPLAN_FILTER_LIST_GSM: string = 'rateplan_filter_list_gsm';
export let CACHE_RATEPLAN_FILTER_LIST_DATA: string = 'rateplan_filter_list_data';
export let CACHE_DEVICE_FILTER_LIST_GSM: string = 'device_filter_list_gsm';
export let CACHE_DEVICE_FILTER_LIST_DATA: string = 'device_filter_list_data';
export let CACHE_FEATURE_FILTER_LIST: string = 'feature_filter_list';
export let CACHE_ACCESSORY_FILTER_LIST: string = 'accessory_filter_list';

export let CACHE_PAYMENT_PUBLIC_KEY: string = 'payment_public_key';
export let CACHE_CREDIT_OPTION_DETAILS: string = 'credit_option_details';

export let CACHE_USER_PROFILE: string = 'user_profile';
export let CACHE_CUSTOMER_DETAILS: string = 'customer_details';
export let CACHE_ORDER_SEARCH_DETAILS: string = 'order_search_details';
export let CACHE_ORDER_DETAILS: string = 'order_details';
export let CACHE_CART_DETAILS: string = 'cart_details';
export let CACHE_RETURN_CART_DETAILS: string = 'return_cart_details';
export let CACHE_SAP_BLIND_CART_DETAILS: string = 'sap_blind_cart_details';


export let IMAGE_BASE_URL = 'https://s.tmocache.com';
export let MAPS_BASE_URL = 'https://maps.t-mobile.com/pcc.html?map=tmo-tom';
export let STORE_LOCATOR_URL = 'https://www.t-mobile.com/store-locator.html';
export let MAPS_COMPARISON_URL = 'https://www.t-mobile.com/coverage/lte-comparison-map-retail';
export let AUTO_ENROLLED_TERMS_URL = 'https://tom.internal.t-mobile.com/webapp/wcs/stores/servlet/TMPLBTermAndConditionView';


export let STORE_ID_CD: number = 10553;
export let STORE_ID_BD: number = 10554;
export let STORE_ID_CS: number = 11051;
export let STORE_ID_TMO: number = 10551;
export let STORE_ID_MYTMO: number = 10552;
export let STORE_ID_RT: number = 11053;

export let CHANNEL_LEGACYQV: string = '11051_LegacyQV';
export let CHANNEL_TIC: string = '11051_TIC';

export let STORE_ID_CD_STR: string = '10553';
export let STORE_ID_BD_STR: string = '10554';
export let STORE_ID_CS_STR: string = '11051';
export let STORE_ID_TMO_STR: string = '10551';
export let STORE_ID_MYTMO_STR: string = '10552';
export let STORE_ID_RT_STR: string = '11053';

export let DEFAULT_ZIP_CODE = '98006';

export let DEFAULT_CREDIT: string = 'DE';
export let AWESOME_CREDIT: string = 'AS';
export let CREDIT_CHECK: string = 'CC';
export let NOCREDIT_CHECK: string = 'NC';

export let LOAN_CRP_DEFAULT: number = 8;
export let LOAN_CRP_AWESOME: number = 8;
export let LOAN_CRP_AVERAGE: number = 3;
export let LEASE_CRP_DEFAULT: number = 101;
export let LEASE_CRP_AWESOME: number = 101;
export let LEASE_CRP_AVERAGE: number = 106;
export let MAX_VOICE_LINES_DEFAULT: number = 12;
export let MAX_DATA_LINES_DEFAULT: number = 5;
export let MAX_ACC_LINES_DEFAULT: number = 20;

export let WORKFLOW_ID_NEW: string = 'ACTIVATION';
export let WORKFLOW_ID_AAL: string = 'ADDALINE';
export let WORKFLOW_ID_EXC: string = 'EXCHANGE';
export let WORKFLOW_ID_CRD: string = 'CREDIT';

export let REF_TYPE_NEW: string = 'new';
export let REF_TYPE_RETURN: string = 'return';
export let REF_TYPE_EXCHANGE: string = 'exchange';
export let REF_TYPE_NORETURN: string = 'noReturn';
export let REF_TYPE_CREDIT: string = 'credit';


export let PACKAGE_TYPE_VOICE: string = 'voice';
export let PACKAGE_TYPE_DATA: string = 'data';
export let PACKAGE_TYPE_PREPAID: string = 'prepaid';
export let PACKAGE_TYPE_ACCESSORY: string = 'accessory';

export let PRODUCT_TYPE_GSM: string = 'GSM';
export let PRODUCT_TYPE_DATA: string = 'DATA';
export let PRODUCT_TYPE_PREPAID: string = 'Prepaid';
export let PRODUCT_TYPE_ACCESSORY: string = 'Accessory';

export let CACHE_DORMANT_FLAG_PROPERTIES: string = 'dormant';

export let PRODUCT_RATEPLAN: string = 'Rateplan';
export let PRODUCT_DEVICE: string = 'Device';
export let PRODUCT_FEATURE: string = 'Feature';
export let PRODUCT_ACCESSORY: string = 'Accessory';

export let CATEGORY_ID_PLAN: number = 4;
export let CATEGORY_ID_DEVICE: number = 2;
export let CATEGORY_ID_FEATURE: number = 3;
export let CATEGORY_ID_ACCESSORY: number = 5;

export let FINANCE_TYPE_FRP: string = 'FRP';
export let FINANCE_TYPE_LOAN: string = 'LOAN';
export let FINANCE_TYPE_LEASE: string = 'LEASE';
export let MIN_EIP_LIMIT: number = 69;

export let RATEPLAN_GRP_NAME_IND: string = 'Individual';
export let RATEPLAN_GRP_NAME_FMY: string = 'Family';

export let DEVICE_GRP_NAME_FAVS: string = 'Favorites';
export let DEVICE_GRP_NAME_MNFR: string = 'Manufacturer';
export let DEVICE_GRP_NAME_TYPE: string = 'Device Type';
export let DEVICE_GRP_NAME_FEATURE: string = 'Feature';

export let FEATURE_GRP_NAME_ACC: string = 'Account Level Feature';
export let FEATURE_GRP_NAME_SUB: string = 'Subscriber Level Feature';
export let FEATURE_GRP_NAME_PROD: string = 'Product Level Feature';

export let ACCESSORY_GRP_NAME_TYPE: string = 'Accessory Type';


export let BTN_ADD: string = 'ADD';
export let BTN_UPDATE: string = 'UPD';
export let BTN_REMOVE: string = 'REM';
export let BTN_DISABLE: string = 'DIS';

export let INSTOCK_CODE: string = 'INS';
export let OUTOFSTOCK_CODE: string = 'OOS';
export let PREORDER_CODE: string = 'PRE';
export let BACKORDER_CODE: string = 'BOA';

export let TAX_INCLUSIVE: string = 'TI';
export let TAX_EXCLUSIVE: string = 'TE';
export let MIXED_TAX_TREATMENT: string = 'MTT';

export let MAXIMUM_COMPARE: number = 5;
export let CARDS_PER_ROW: number = 3;
export let CARDS_PER_PAGE: number = 12;
export let ORDERS_PER_PAGE: number = 25;

export let BANNER_GSM_RATEPLAN = 'BannerContentSpot_Rateplan_GSM';
export let BANNER_MI_RATEPLAN = 'BannerContentSpot_Rateplan_DATA';
export let BANNER_GSM_DEVICE = 'BannerContentSpot_Device_GSM';
export let BANNER_MI_DEVICE = 'BannerContentSpot_Device_DATA';
export let BANNER_ACCESSORIES = 'BannerContentSpot_Accessories';
export let PIN = 'pin';

export let SUGGESTIONS_GSM_RATEPLAN = 'SuggestionsContentSpot_Rateplan_GSM';
export let SUGGESTIONS_MI_RATEPLAN = 'SuggestionsContentSpot_Rateplan_DATA';
export let SUGGESTIONS_GSM_DEVICE = 'SuggestionsContentSpot_Device_GSM';
export let SUGGESTIONS_MI_DEVICE = 'SuggestionsContentSpot_Device_DATA';
export let SUGGESTIONS_ACCESSORY = 'SuggestionsContentSpot_Accessories';

// US335007: BannerContentSpot_ZipCode
export let BANNER_ZIPCODE = 'BannerContentSpot_ZipCode';

export let MAX_DUPLICATE_MAPPING: number = 4;
// trade in Values
export let ACCOUNT_TYPE_I = 'I';
export let ACCOUNT_SUB_TYPE_S = 'S';
export let ACCOUNT_SUB_TYPE_R = 'R';
export let ACCOUNT_SUB_TYPE_Q = 'Q';
export let ACCOUNT_SUB_TYPE_M = 'M';


export let PROGRAM_TYPE_DRP = 'DRP';


export let ADD_A_LINE = 'ADDALINE';
export let NEW_ACTIVATION = 'ACTIVATION';
export let ELIGIBILITY_TYPE = 'ALL';
export let SALES_CHANNEL = 'TELESALES';


export let PRICING_OPTION = 'EIP';
export let PROMOTION_TYPE = 'TRADEIN';
export let TRADEIN_PRODUCT_TYPE = 'DEVICE';
export let DEFAULT_PHONE_NUMBER = '0000000000';
export let TRADEIN_INTENT = 'STANDARD';
export let TRADEIN_STATUS_CODE = 'REJECTED';
export let TRADEIN_DEVICE_EXPIRATION_MESSAGE = 'Sorry this device is no more eligbile for trade-in.Please select otherdevice.';
export let PRIMARY_VOICE_LINE = 'Voice Line ';

export let PAYMENT_METHOD_CREDIT = 'CREDIT';
export let PAYMENT_METHOD_WEBPAYMENT = 'WEBPAYMENT';
export let VISA = 'VISA';

export let CARD_TYPE_MASTERCARD = 'Master Card';
export let CARD_TYPE_AMERICAN = 'AMEX';
export let SIM_LENGTH: number = 19;

/*order status constants*/
export let ORDER_STATUS_S = 'S';
export let ORDER_STATUS_C = 'C';
export let ORDER_STATUS_X = 'X';
export let ORDER_STATUS_B = 'B';
export let ORDER_STATUS_DC = 'DC';
export let ORDER_STATUS_P = 'P';
export let ORDER_STATUS_P1 = 'P1';
export let ORDER_STATUS_P2 = 'P2';
export let ORDER_STATUS_P3 = 'P3';
export let ORDER_STATUS_P4 = 'P4';
export let ORDER_STATUS_P5 = 'P5';
export let ORDER_STATUS_P6 = 'P6';
export let ORDER_STATUS_P7 = 'P7';
export let ORDER_STATUS_P8 = 'P8';
export let ORDER_STATUS_P9 = 'P9';
export let ORDER_STATUS_P10 = 'P10';
export let ORDER_STATUS_P11 = 'P11';
export let ORDER_STATUS_P12 = 'P12';
export let ORDER_STATUS_P13 = 'P13';
export let ORDER_STATUS_P14 = 'P14';
export let ORDER_STATUS_P15 = 'P15';
export let ORDER_STATUS_P16 = 'P16';
export let ORDER_STATUS_P17 = 'P17';
export let ORDER_STATUS_P18 = 'P18';
export let ORDER_STATUS_P19 = 'P19';
export let ORDER_STATUS_P20 = 'P20';
export let ORDER_STATUS_P21 = 'P21';

export let STANDARD_TRADEIN = 'Standard Trade-In';
export let TRADE_IN_OFFER_DISPLAY = 'Device Trade-In must be sent to receive the offer';
export let NOT_FOUND = 'Not Found';
export let SHIP_MODE_SHOPIFY = 'Shopify';
export let SHIP_MODE_BOTH = 'Both';
export let CUSTOMER = 'customer';
export let STATUS_CODE_SUPPORTED = 'Supported';
export let ENGLISH = 'english';
export let SUCCESS = 'SUCCESS';
export let ORDER_NOTES_MODAL = 'orderNotesModal';
export let CLEAR_ALL_MODAL = 'clearAllModal';
export let OVERVIEW = 'overview';
export let COMPATIBILITY = 'compatibility';
export let EMAIL = 'email1';
export let CUSTOMER_PHONE = 'phone1';
export let NON_TMO_MOBILENUMBER = 'nonTMOMobileNumber';
export let MIDDLE_NAME = 'middleName';
export let WEB_ORDER_ID = 'webOrderId';
export let CREDIT_TYPE_CC = 'CC';
export let CREDIT_TYPE_NC = 'NC';
export let DEPOSIT_TYPE_FULL = 'FULL';
export let CREDIT_PROFILE = 'creditProfile';
export let ORDERS = 'orders';
export let SUBSCRIBERS = 'subscribers';
export let ADD_LINE = 'AAL';
export let NEW_PACKAGE = 'NEW';
export let GROUP_NAME_SUB = 'SUB';
export let GROUP_NAME_ACC = 'ACC';
export let GROUP_NAME_PROD = 'PROD';
export let OUT_OF_STOCK = 'Out of stock';
export let MOBILE_NUMBER= 'mobilenumber';

export let FULL_PRICE = 'Full Price';
export let JUMP_ON_DEMAND = 'JUMP! On Demand';
//export let ORDER_ITEM_ID = 'orderItemId';
export let MSISDN = 'msisdn';
export let DEVICE_ITEM_STATUS = 'OOS';
export let BUY_BACK_OFFER = 'Buyback offer is too low.';
export let STATUS_CODE_OFFERED = 'OFFERED';
export let STATUS_CODE_ELIGIBLE = 'ELIGIBLE';
export let MODEL = 'model';
export let SERVICE = 'service';
export let TRADEIN_QUOTES = 'standard';
export let TRADEIN_BILL_CREDIT = ' in Bill Credit for your device trade-in.';
export let EIP_ESTIMATE_STATUS = 'success';
export let FAILURE = 'Failure';
export let SUCCESS_DESC = 'Success';
export let EMAIL_OPTION = 'SEND_EMAIL';
export let STATUS_COMPLETED = 'Completed';
export let STATUS_SAPCCDECLINE = 'SAP CC Decline';
export let STATUS_PENDING = 'Pending';
export let STATUS_CANCELLED = 'Cancelled';
export let STATUS_NOT_AVAILABLE = 'N/A';
export let SELECTED_STATUS = 'All';
export let IDENTIFIER_TYPE_PWD = 'PWD';
export let IDENTIFIER_TYPE_PIN = 'PIN';
export let IDENTIFIER_TYPE_SSN = 'SSN';
export let VERIFICATION_STATUS = 'verified';
export let BYPASS_STATUS = 'bypass';
export let PASSCODE_PLACE_HOLDER = 'Passcode*';
export let SSN_PLACE_HOLDER = 'Last 4 Digits SSN*';
export let SHIPPING_NOT_ALLOWED = 'No shipping needed for this order';

export let CREDIT_CLASS_S = 'S';
export let CREDIT_CLASS_Q = 'Q';
export let CREDIT_CLASS_A = 'A';
export let CREDIT_CLASS_C = 'C';

export let CUSTOMER_VERIFICATION = 'Customer Verification';
export let TOKEN_VERIFIED = 'Customer Verification was completed.';
export let BYPASSED_VALIDATION = 'Customer Verification was bypassed for reason:';
export let BYPASSED_VALIDATION_RETAIL1 = 'In Person Verification completed for '
export let BYPASSED_VALIDATION_RETAIL2 = ' by using ';
export let OTP_VERIFIED = 'One-Time PIN Verification was completed.';
export let CUSTOMER_VERIFICATION_EXTERNALLY = 'Account verified externally.';
export let CUSTOMER_VERIFICATION_BYPASS = 'Customer Verification was bypassed.';
export let TOKEN_VERIFIED_EXTERNALLY = 'Token Verification  was completed.';

export let ORDER_SOFT_REJECT = 'SOFT_REJECT';
export let ORDER_HARD_REJECT = 'HARD_REJECT';
export let ORDER_FRAUD_REVIEW = '_ERR_FRAUD_REVIEW';
export let EIP_DISCLOSURECREATE_ERROR = '_ERR_EIP_DISCLOSURECREATE_ERROR';

export let BLIND_ORDER_REF = 'blindOrder';
export let MEMO_RETURN_CODE: string = 'HOR';
export let MEMO_RETURN_CODE_VALUE: string = 'HO Return Success';
export let MEMO_REFUND_CODE: string = 'EPYM';
export let MEMO_REFUND_CODE_VALUE: string = 'Purchase or Credit';
export let MEMO_RESEND_CODE: string = 'RLBD';
export let MEMO_RESEND_CODE_VALUE: string = 'Telesales Resend Shipping label';

export let ORDER_STATUS_PES = 'PES';
export let PURCHASE_EST_SENT = 'Purchase Est Sent';

export let SAMSON_MEMO_CODE_FRAUD_REJECT= 'CRDR';
export let SAMSON_MEMO_CODE_TEXT_FRAUD_REJECT= 'CPR Reject';
export let SAMSON_MEMO_TEXT_FRAUD_REJECT = 'CPR Reject: Transaction stopped. The information provided could not be verified and order <insert order number> cannot be completed. Please refer customer to a T-Mobile retail store for this transaction.'

export let MAX_PED_RESEND_DAYS: number = 45;
export let DOB_55_PLUS_RATEPLANS: string = '01/01/1950';

export let NOT_AUTHORIZED: string = 'Not Authorized';
export let PRIMARY: string = 'Primary';
export let FULL_ACCESS: string = 'Full Access';
export let STANDARD: string = 'Standard';

export let PAH: string = 'PAH';
export let NPAH_P: string = 'NPAH_P';
export let NPAH_NP: string = 'NPAH_NP';


